import {
  useAxios,
  useHandleApiError,
} from '@sttedra_ui/framework';
import TutorialApiModel from './tutorial.api-model';
import TutorialController from './tutorial.controller';
import MOCK_TUTORIAL from './mock-tutorial.json';

// #region Globals
const {base} = useAxios();
const CONTEXT_BASE_PATH = 'tutorial/gettutorialtextosbyculture';
const DEFAULT_TIMEOUT = 5000;
const {handleApiError} = useHandleApiError();
// #endregion

// #region Public functions

async function getTutorials(mock = false) {
  try {
    let tutorialData = MOCK_TUTORIAL;
    if (!mock) {
      const url = '/' + CONTEXT_BASE_PATH;
      const {data: originalData} = await base.get(url, {
        timeout: DEFAULT_TIMEOUT,
      });
      tutorialData = originalData;
    }

    const tutorials = tutorialData.map((tutorial) => new TutorialApiModel(tutorial));
    return new TutorialController(tutorials);
  } catch (err) {
    return handleApiError(err);
  }
}

// #endregion

export {
  getTutorials,
};
